import { Component } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { DialogModule } from 'primeng/dialog';
import { Subscription } from 'rxjs';
import { ToastService } from 'src/services/toast.service';
import { GlobalService } from 'src/services/global.service';

@Component({
  selector: 'dialog-loading',
  templateUrl: './dialog-loading.component.html',
  standalone: true,
  imports: [DialogModule, LottieComponent],
})
export class _DialogLoadingComponent {
  visible: boolean = false;
  visible$?: Subscription;

  options: AnimationOptions = {
    path: '/assets/loading.json',
  };

  constructor(public globalService: GlobalService) {}

  ngOnInit(): void {
    this.visible$ = this.globalService.showLoading$.subscribe((visible) => {
      this.visible = visible;
    });
  }

  ngOnDestroy(): void {
    this.visible$?.unsubscribe();
  }

  protected _hide() {
    this.globalService.hideLoading();
  }

  protected _onVisibleChange(visible: boolean) {
    if (visible) this.globalService.showComingSoon();
    else this.globalService.hideLoading();
  }
}
